import { Injectable } from '@angular/core';
import { LengthTypes } from '../../enums';

@Injectable({
    providedIn: "root"
})
export class LengthCalculatorService {
    getConvertedLength(sourceLength: (number | string | null | undefined), sourceType: LengthTypes, targetType: LengthTypes): number {
        if (sourceLength && parseFloat('' + sourceLength) <= 0)
            return 0;

        const source = this.lengthTypeMaps.filter(x => x.type === sourceType)[0];
        const target = this.lengthTypeMaps.filter(x => x.type === targetType)[0];

        if (!source || !target)
            return 0;

        const val = parseFloat('' + sourceLength);
        const convertedValue = this.round((val * source.value / target.value), 12);

        return convertedValue;
    }

    private round = (value: number, decimal: number): number => {
        return Math.round(Math.pow(10, decimal) * value) / Math.pow(10, decimal);
    }

    private lengthTypeMaps: { type: LengthTypes, value: number }[] =
        [
            { type: LengthTypes.Meter, value: 1.00 },
            { type: LengthTypes.MicroMeter, value: 0.000001 },
            { type: LengthTypes.MilliMeter, value: 0.001 },
            { type: LengthTypes.CentiMeter, value: 0.01 },
            { type: LengthTypes.DeciMeter, value: 0.10 },
            { type: LengthTypes.DekaMeter, value: 10.00 },
            { type: LengthTypes.HectoMeter, value: 100.00 },
            { type: LengthTypes.KilloMeter, value: 1000.00 },
            { type: LengthTypes.Angstrom, value: (1.00 / Math.pow(10, 10)) },
            { type: LengthTypes.Inch, value: 0.0254 },
            { type: LengthTypes.Feet, value: 0.3048 },
            { type: LengthTypes.Yard, value: 0.9144 },
            { type: LengthTypes.RodOrPoleOrPerch, value: 5.0292 },
            { type: LengthTypes.Chain, value: 20.1168 },
            { type: LengthTypes.Furlong, value: 201.168 },
            { type: LengthTypes.Mile, value: 1609.344 },
            { type: LengthTypes.Hand, value: 0.1016 },
            { type: LengthTypes.Mil, value: 0.0000254 },
            { type: LengthTypes.CableLength, value: 219.456 },
            { type: LengthTypes.Fathom, value: 1.8288 },
            { type: LengthTypes.NauticalLeague, value: 5556.00 },
            { type: LengthTypes.NauticalMile, value: 1852.00 }
        ];
}